import { render, staticRenderFns } from "./DuplicateColumnMenu.vue?vue&type=template&id=198f6466&"
import script from "./DuplicateColumnMenu.vue?vue&type=script&lang=js&"
export * from "./DuplicateColumnMenu.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateColumnMenu.vue?vue&type=style&index=0&id=198f6466&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports